module.exports = __webpack_public_path__ + "static/media/member.f6856939.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/MemberPopup/assets/member.png
// module id = xtxt
// module chunks = 24